import {
  ES_CONTRACT_GET_LIST,
  ES_CONTRACT_GET_LIST_SUCCESS,
  ES_CONTRACT_GET_LIST_ERROR,
  ES_CONTRACT_GET_BY_ID,
  ES_CONTRACT_GET_BY_ID_SUCCESS,
  ES_CONTRACT_GET_BY_ID_ERROR,
  ES_CONTRACT_ADD_ITEM,
  ES_CONTRACT_ADD_ITEM_SUCCESS,
  ES_CONTRACT_ADD_ITEM_ERROR,
  ES_CONTRACT_EDIT_ITEM,
  ES_CONTRACT_EDIT_ITEM_SUCCESS,
  ES_CONTRACT_EDIT_ITEM_ERROR,
  ES_CONTRACT_DELETE_ITEM,
  ES_CONTRACT_DELETE_ITEM_SUCCESS,
  ES_CONTRACT_DELETE_ITEM_ERROR,
} from '../actions';

//esContract
const initialState = {
  esContracts: [],
  esContract: null,
  error: '',
  loading: false,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default function reducerState(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case ES_CONTRACT_GET_BY_ID:
    case ES_CONTRACT_GET_LIST:
      return {
        ...state,
        loading: true,
        editSuccess: false,
      };

    case ES_CONTRACT_GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        esContracts: payload,
      };

    case ES_CONTRACT_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        esContract: payload,
      };

    case ES_CONTRACT_ADD_ITEM:
      return {
        ...state,
        loading: true,
        addSuccess: false,
      };

    case ES_CONTRACT_ADD_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        esContracts: payload,
        addSuccess: true,
      };
    case ES_CONTRACT_EDIT_ITEM:
      return {
        ...state,
        loading: true,
        editSuccess: false,
      };

    case ES_CONTRACT_EDIT_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        esContracts: payload,
        editSuccess: true,
      };

    case ES_CONTRACT_DELETE_ITEM:
      return {
        ...state,
        loading: true,
        deleteSuccess: false,
      };
    case ES_CONTRACT_DELETE_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        esContracts: payload,
        deleteSuccess: true,
      };

    case ES_CONTRACT_GET_LIST_ERROR:
    case ES_CONTRACT_ADD_ITEM_ERROR:
    case ES_CONTRACT_EDIT_ITEM_ERROR:
    case ES_CONTRACT_DELETE_ITEM_ERROR:
    case ES_CONTRACT_GET_BY_ID_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
}
